import './App.css'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import Instructions from './Game/Instructions'
import Start from './Game/Start'

function App() {
  return (
    <Router>
      <Switch>
        <Route path='/start'>
          <Start />
        </Route>
        <Route path='/'>
          <Instructions />
        </Route>
      </Switch>
    </Router>
  )
}

export default App

